import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLocation } from 'react-router';

import useScrollToTop from '../../hooks/useScrollToTop';
import * as AppPropTypes from '../../lib/PropTypes';

import Button from '../buttons/CtaButton';
import EditionCard from '../cards/EditionCard';
import Header from '../headers/Header';
import ArrowIcon from '../icons/Arrow';

import styles from '../../../styles/pages/editions.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const EditionsPage = ({ page, className }) => {
    const intl = useIntl();
    // const handle = useUrlFromHandle();
    const { pathname = null } = useLocation();

    const { title = null, editions = null, url = null } = page || {};

    const firstYear = 1971;
    const latestYear = Math.max(...editions.map((it) => parseInt(it.label, 10)));
    const previousEditions = editions !== null ? editions.slice(1) : null;
    const latestEdition = editions !== null && editions.length > 0 ? editions[0] : null;

    const {
        handle: latestHandle = null,
        startDate = null,
        endDate = null,
        page: editionPage = null,
    } = latestEdition || {};

    const latestEditionPage = editionPage || null;

    useScrollToTop(page, pathname, url);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.header}>
                {title !== null ? (
                    <Header
                        page={page}
                        type="page"
                        backgroundText={
                            <div className={styles.backgroundText}>
                                {firstYear}
                                <ArrowIcon className={styles.backgroundArrow} />
                                {latestYear}
                            </div>
                        }
                    />
                ) : null}
            </div>
            {latestEdition !== null ? (
                <div className={styles.latest}>
                    <EditionCard
                        className={styles.latestEdition}
                        item={latestEdition}
                        withoutYear
                    />
                    <div className={styles.latestInfo}>
                        {latestHandle !== null ? (
                            <h3 className={styles.title}>
                                <FormattedMessage
                                    defaultMessage="Edition {year}"
                                    description="Section heading"
                                    values={{ year: latestHandle }}
                                />
                            </h3>
                        ) : null}
                        {startDate !== null && endDate !== null ? (
                            <>
                                <h4 className={styles.subtitle}>
                                    <FormattedMessage
                                        defaultMessage="Presented from {start}"
                                        description="Date"
                                        values={{
                                            start: intl.formatDate(startDate, {
                                                month: 'long',
                                                day: 'numeric',
                                                year: 'numeric',
                                            }),
                                        }}
                                    />
                                </h4>
                                <h4>
                                    <FormattedMessage
                                        defaultMessage="to {end}"
                                        description="Date"
                                        values={{
                                            end: intl.formatDate(endDate, {
                                                month: 'long',
                                                day: 'numeric',
                                                year: 'numeric',
                                            }),
                                        }}
                                    />
                                </h4>
                            </>
                        ) : null}
                        <div className={styles.buttons}>
                            {latestEditionPage ? (
                                <div className={styles.button}>
                                    <Button href={latestEditionPage?.url}>
                                        <FormattedMessage
                                            defaultMessage="View edition"
                                            description="Button label"
                                        />
                                    </Button>
                                </div>
                            ) : null}
                            {/* <div className={styles.button}>
                                <Button
                                    className={styles.button}
                                    href={`${handle('films')}/edition/${latestHandle}`}
                                >
                                    <FormattedMessage
                                        defaultMessage="View films"
                                        description="Button label"
                                    />
                                </Button>
                            </div> */}
                        </div>
                    </div>
                </div>
            ) : null}
            {previousEditions !== null && previousEditions.length > 0 ? (
                <div className={styles.previous}>
                    <h2 className={styles.heading}>
                        <FormattedMessage
                            defaultMessage="Previous editions"
                            description="Section heading"
                        />
                    </h2>
                    <div className={styles.grid}>
                        {(previousEditions || []).map((edition) => {
                            const { id, handle: editionHandle, poster = null } = edition || {};
                            return poster !== null ? (
                                <EditionCard
                                    key={`${id}-${editionHandle}`}
                                    className={styles.edition}
                                    item={edition}
                                />
                            ) : null;
                        })}
                    </div>
                </div>
            ) : null}
        </div>
    );
};
EditionsPage.propTypes = propTypes;
EditionsPage.defaultProps = defaultProps;

export default EditionsPage;
